'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import { CustomError } from '@core/utils';
import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { AuthMutation, AuthQueryOptions } from '@/api';
import { parseKstDateToMs } from '../../_utils/countdown';
export interface CoupangEarnData {
  /** 서버가 내려주는 재지급 가능 시각 epoch ms. 지금 지급 가능하면 null */
  nextAvailableAtMs: number | null;
  /** 이번 참여 시 지급되는 포인트. 서버가 안 내려주면 null */
  rewardPoint: number | null;
  dailyRewardLimit: number | null;
}

//* 도메인 쿨다운(재참여 불가) 에러 코드. wire status는 200이며 return_code로 판정한다.
const COOLDOWN_RETURN_CODE = 30400;
export const useCoupangEarn = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...AuthQueryOptions["get:/wello/v2/auth/point/coupang-banner/status"](),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useSuspenseQuery(t0);
};
export const useClaimCoupang = () => {
  const $ = _c(4);
  const queryClient = useQueryClient();
  const {
    toast
  } = useToast();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = AuthMutation["post:/wello/v2/auth/point/coupang-banner"]();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== queryClient || $[2] !== toast) {
    t1 = {
      ...t0,
      onSuccess: response => {
        const addedPoints = response.context?.addPoints;
        toast({
          message: addedPoints ? `${addedPoints}P가 적립됐어요` : "\uC801\uB9BD\uB410\uC5B4\uC694"
        });
        return Promise.all([queryClient.invalidateQueries({
          queryKey: AuthQueryOptions["get:/wello/v2/auth/point/coupang-banner/status"]().queryKey
        }), queryClient.invalidateQueries({
          queryKey: AuthQueryOptions["get:/wello/v2/auth/point"]().queryKey
        })]);
      },
      onError: error => {
        if (error instanceof CustomError && error.return_code === COOLDOWN_RETURN_CODE) {
          toast({
            message: "\uC544\uC9C1 \uC7AC\uCC38\uC5EC\uD560 \uC218 \uC5C6\uC5B4\uC694",
            type: "fail"
          });
          return queryClient.invalidateQueries({
            queryKey: AuthQueryOptions["get:/wello/v2/auth/point/coupang-banner/status"]().queryKey
          });
        }
        toast({
          message: "\uC801\uB9BD\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
          type: "fail"
        });
      }
    };
    $[1] = queryClient;
    $[2] = toast;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useMutation(t1);
};
function _temp(response) {
  return {
    nextAvailableAtMs: response.context?.nextAvailableAt ? parseKstDateToMs(response.context.nextAvailableAt) : null,
    rewardPoint: response.context?.rewardPoint ?? null,
    dailyRewardLimit: response.context?.dailyRewardLimit ?? null
  };
}